/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UserSessionIssuer,
  UserSessionIssuer$inboundSchema,
} from "./usersessionissuer.js";

/**
 * Result type for listing the user_session_issuers in an organization.
 */
export type ListOrganizationUserSessionIssuersResult = {
  items: Array<UserSessionIssuer>;
  /**
   * Cursor for the next page; empty when exhausted.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListOrganizationUserSessionIssuersResult$inboundSchema:
  z.ZodMiniType<ListOrganizationUserSessionIssuersResult, unknown> = z.pipe(
    z.object({
      items: z.array(UserSessionIssuer$inboundSchema),
      next_cursor: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        "next_cursor": "nextCursor",
      });
    }),
  );

export function listOrganizationUserSessionIssuersResultFromJSON(
  jsonString: string,
): SafeParseResult<
  ListOrganizationUserSessionIssuersResult,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListOrganizationUserSessionIssuersResult$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListOrganizationUserSessionIssuersResult' from JSON`,
  );
}
